<template>
  <b-card
    border-variant="primary" header-bg-variant="primary" header-text-variant="white"
    header-class="p-3 font-size-lg font-weight-bold"
    header="Commission — producing broker, Fuse income, Guy Carpenter"
  >
    <div v-if="configStrip" class="small mb-3 p-2 border rounded bg-light">
      {{ configStrip }}
    </div>

    <table class="table table-sm table-bordered mb-0">
      <thead>
        <tr>
          <th width="28%" class="text-center">Who earns this share</th>
          <th width="12%" class="text-center">INSIGHT id</th>
          <th width="8%" class="text-center">%</th>
          <th width="13%" class="text-center">Commission</th>
          <th width="13%" class="text-center">Comm. GST</th>
          <th width="13%" class="text-center">Broker Fee</th>
          <th width="13%" class="text-center">Fee GST</th>
        </tr>
      </thead>

      <tr v-for="(ar, index) in arSplit" :key="index" class="text-center">
        <td class="align-middle text-left">
          <div class="font-weight-bold">{{ ar.roleLabel || ar.role || "Commission share" }}</div>
          <div class="small text-muted">{{ ar.purpose || "" }}</div>
        </td>
        <td class="align-middle">{{ ar.authorisedRepId != null ? ar.authorisedRepId : "—" }}</td>
        <td class="align-middle">{{ ar.pct }}%</td>
        <td class="text-right">{{ ar.commission | currency }}</td>
        <td class="text-right">{{ ar.gst | currency }}</td>
        <td class="text-right">{{ ar.fee | currency }}</td>
        <td class="text-right">{{ ar.feeGst | currency }}</td>
      </tr>

      <tr class="text-center font-weight-bolder" style="background-color: lightgray">
        <td class="align-middle" colspan="2">Total</td>
        <td class="align-middle">{{ totalPct }}%</td>
        <td class="text-right">{{ totalCommission | currency }}</td>
        <td class="text-right">{{ totalGst | currency }}</td>
        <td class="text-right">{{ totalFee | currency }}</td>
        <td class="text-right">{{ totalFeeGst | currency }}</td>
      </tr>
    </table>
  </b-card>
</template>

<script>
export default {
  name: "ArSplitTable",

  props: {
    arSplit: {
      type: Array,
      required: true
    },
    commissionConfig: {
      type: Object,
      default: null
    }
  },

  computed: {
    configStrip: function () {
      const cfg = this.commissionConfig;
      if (!cfg) {
        return "Commission configuration missing — percentages not proved";
      }
      const total = cfg.totalBrokeragePercent != null ? `${cfg.totalBrokeragePercent}%` : "missing";
      const gc = cfg.guyCarpenterPercent != null ? `${cfg.guyCarpenterPercent}%` : "missing";
      const broker = cfg.producingBrokerPercent != null ? `${cfg.producingBrokerPercent}%` : "missing";
      const fuse = cfg.fusePercent != null ? `${cfg.fusePercent}%` : "missing";
      return `Total brokerage ${total} · Guy Carpenter ${gc} · Producing broker ${broker} · Fuse ${fuse}`;
    },
    totalPct: function () {
      return this.round(this.sum("pct"));
    },
    totalCommission: function () {
      return this.round(this.sum("commission"));
    },
    totalGst: function () {
      return this.round(this.sum("gst"));
    },
    totalFee: function () {
      return this.round(this.sum("fee"));
    },
    totalFeeGst: function () {
      return this.round(this.sum("feeGst"));
    }
  },

  methods: {
    sum: function (key) {
      return this.arSplit.reduce((acc, ar) => acc + Number(ar[key] || 0), 0);
    },
    round: function (number) {
      return Math.round((Number(number) + Number.EPSILON) * 100) / 100;
    }
  }
};
</script>
